import { Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import dayjs from "dayjs";

export const getColumns = (setSelectedSchedule, setOpenDeleteDialog) => [
  {
    field: "bay",
    headerName: "Bay",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "time",
    headerName: "Time",
    flex: 1,
    minWidth: 120,
  },
  {
    field: "created_at",
    headerName: "Created At",
    flex: 1,
    minWidth: 180,
    valueFormatter: (params) => {
      return params ? dayjs(params).format("DD-MM-YYYY hh:mm A") : "-";
    },
  },
  {
    field: "created_by",
    headerName: "Created By",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 120,
    sortable: false,
    renderCell: (params) => (
      <Button
        variant="outlined"
        size="small"
        startIcon={<DeleteIcon />}
        onClick={() => {
          setSelectedSchedule(params.row);
          setOpenDeleteDialog(true);
        }}
        sx={{
          color: "#f44336",
          borderColor: "#f44336",
          "&:hover": {
            borderColor: "#d32f2f",
            backgroundColor: "rgba(244, 67, 54, 0.04)",
          },
          textTransform: "none",
          fontSize: "12px",
          minWidth: "80px",
        }}
      >
        Delete
      </Button>
    ),
  },
];